import { Check, Menu } from "lucide-react";
import { cn } from "@/lib/utils";
import { Frame, MiniHubFace, Window } from "./WindowsVisuals";

const HEART = [1, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 16, 17, 18, 22];

const Item = ({ on, children }) => (
  <p className={cn("rounded px-2 py-1", on ? "bg-primary font-semibold text-primary-foreground" : "text-muted-foreground")}>{children}</p>
);

export const PybricksMenu = () => (
  <Frame testId="ready-visual-pybricks-menu" caption="code.pybricks.com → menu → Install Pybricks Firmware">
    <Window title="code.pybricks.com">
      <div className="flex gap-2">
        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded bg-primary text-primary-foreground"><Menu className="h-3.5 w-3.5" /></span>
        <div className="flex-1 rounded border bg-background p-1">
          <Item>Settings</Item>
          <Item on>Install Pybricks Firmware</Item>
          <Item>Restore Official LEGO Firmware</Item>
        </div>
      </div>
    </Window>
  </Frame>
);

export const PickHub = () => (
  <Frame testId="ready-visual-pick-hub" caption="Pick the SPIKE Prime hub, then accept the licence">
    <Window title="Install Pybricks Firmware">
      <p className="px-1 pb-1 font-semibold">Select your hub</p>
      <Item>SPIKE Essential Hub</Item>
      <Item on>SPIKE Prime Hub</Item>
      <Item>MINDSTORMS Robot Inventor Hub</Item>
    </Window>
  </Frame>
);

export const HubName = () => (
  <Frame testId="ready-visual-hub-name" caption="Type a short name, then stick the same name on the hub">
    <Window title="Hub name">
      <div className="rounded border border-primary bg-background px-2 py-1.5 font-mono text-xs">HP-R4-07<span className="hp-caret ml-px inline-block h-3 w-px translate-y-0.5 bg-foreground" /></div>
    </Window>
    <span className="rotate-[-3deg] rounded-md border-2 border-dashed border-accent bg-card px-3 py-1 font-mono text-xs font-bold">HP-R4-07</span>
  </Frame>
);

export const InstallProgress = () => (
  <Frame testId="ready-visual-install" caption="Pick the hub in the pop-up, then wait for the bar to fill">
    <Window title="code.pybricks.com wants to connect">
      <p className="mx-1 rounded bg-primary px-1.5 py-1 font-semibold text-primary-foreground">LEGO Technic Large Hub in DFU Mode</p>
      <div className="mt-2 flex justify-end gap-1.5 px-1"><span className="rounded border px-2 py-0.5">Cancel</span><span className="rounded bg-primary px-2 py-0.5 font-semibold text-primary-foreground">Connect</span></div>
    </Window>
    <div className="h-2 w-full max-w-[260px] overflow-hidden rounded-full border bg-background"><div className="hp-fill h-full rounded-full bg-primary" /></div>
  </Frame>
);

export const HubReadyVisual = () => (
  <Frame testId="ready-visual-hub-ready" caption="Unplugged, switched on, ready to pair">
    <MiniHubFace pixels={HEART} />
    <span className="flex items-center gap-1.5 text-xs font-semibold text-[hsl(var(--success))]"><Check className="h-4 w-4" strokeWidth={3} />Pybricks firmware installed</span>
  </Frame>
);
